module.exports = __webpack_public_path__ + "static/media/x-white.9d4583ed.svg";